function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Architect-Engineer-Profession-Job-Business_Plan",
  "data-name": "Architect-Engineer-Profession-Job-Business Plan"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e04e12",
  d: "m26 39h4v2h-4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e04e12",
  d: "m14 31h2v10h-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e04e12",
  d: "m18 31h2v10h-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e04e12",
  d: "m26 35h4v2h-4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e04e12",
  d: "m18 15h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e04e12",
  d: "m22 15h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e04e12",
  d: "m22 19h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e04e12",
  d: "m18 19h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e04e12",
  d: "m22 23h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e04e12",
  d: "m26 15h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e04e12",
  d: "m26 19h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e04e12",
  d: "m26 23h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e04e12",
  d: "m26 27h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e04e12",
  d: "m18 23h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e04e12",
  d: "m55.49 46.36a1.865 1.865 0 0 0 -.59-.63l-1.9-1.27v-.72a7 7 0 0 0 2.71-3.77 2.85 2.85 0 0 0 .29.03 3.983 3.983 0 0 0 2.92-6.71 2.977 2.977 0 0 0 -.96-5.12 9.059 9.059 0 0 0 -6.19-7.73l.02-.11a1.982 1.982 0 0 0 -.44-1.62 2.018 2.018 0 0 0 -1.53-.71h-1.64a2.018 2.018 0 0 0 -1.53.71 1.982 1.982 0 0 0 -.44 1.62l.02.11a9.059 9.059 0 0 0 -6.19 7.73 2.977 2.977 0 0 0 -.96 5.12 3.983 3.983 0 0 0 2.92 6.71 2.85 2.85 0 0 0 .29-.03 7 7 0 0 0 2.71 3.77v.72l-1.91 1.27a1.874 1.874 0 0 0 -.57.62h-.02a8.644 8.644 0 0 0 -2.5 1.16v-6.51a2.006 2.006 0 0 0 -2-2h-4v-6a2.006 2.006 0 0 0 -2-2v-18a2.006 2.006 0 0 0 -2-2h-2v-5h-2v5h-2v-9h-2v9h-2v-5h-2v5h-2a2.006 2.006 0 0 0 -2 2v14h-2a2.006 2.006 0 0 0 -2 2v10h-2v-2a2.006 2.006 0 0 0 -2-2h-1a3.009 3.009 0 0 0 -3 3v19a5 5 0 0 0 5 5h54a1 1 0 0 0 1-1v-6a8.932 8.932 0 0 0 -6.51-8.64zm-1.72.99c0 .02.01.05.01.07l-1.28 3.5c-.02-.03-2.16-2.04-2.16-2.04l1.9-2.53zm-4.77-.02-1.96-2.62a6.768 6.768 0 0 0 3.92 0v.01zm1.15 4.1-.57.57h-1.16l-.57-.57 1.15-1.06zm5.85-13.43v-4a2 2 0 0 1 0 4zm-6.18-18-.64 3.85a.191.191 0 0 1 -.36 0l-.64-3.85zm-3.26 2.45.29 1.73a2.18 2.18 0 0 0 4.3 0l.29-1.73a7.026 7.026 0 0 1 4.47 5.55h-13.82a7.026 7.026 0 0 1 4.47-5.55zm-4.56 15.55a2 2 0 0 1 0-4zm-1-6a1 1 0 0 1 0-2h16a1 1 0 0 1 0 2zm3 6v-4h10v4a5 5 0 0 1 -10 0zm.2 9.39 1.57-1.03 1.89 2.52s-2.16 1.95-2.19 1.99l-1.27-3.44zm-12.2-14.39v10h-8v-10zm-16-20h14v18h-6v-2a2.006 2.006 0 0 0 -2-2h-6zm-4 16h10v14h-10zm22 16v4h-24v-4zm-26-4h2v2a2.006 2.006 0 0 0 -2 2zm-4-3a1 1 0 0 1 1-1h1l-.04 15.11a4.95 4.95 0 0 0 -1.96.9zm32 19h-20.53a9.534 9.534 0 0 1 -4.23-1 9.534 9.534 0 0 1 4.23-1h20.53zm.23-4h-20.76a11.476 11.476 0 0 0 -5.12 1.21 1.994 1.994 0 0 0 -.01 3.57 11.426 11.426 0 0 0 5.13 1.22h20.53v1h-29a3 3 0 0 1 -.63-5.93 2.01 2.01 0 0 0 1.63-1.97v-3.1a2.006 2.006 0 0 0 2 2h24a2.006 2.006 0 0 0 2-2v-4a2.006 2.006 0 0 0 -2-2v-2h4v8.35a8.815 8.815 0 0 0 -1.77 3.65zm8.99 7h-2.22v-6h-2v6h-3v-5a8.144 8.144 0 0 1 .05-.87 7.047 7.047 0 0 1 1.7-3.76 6.857 6.857 0 0 1 2.72-1.9l1.1 3.03a2 2 0 0 0 1.57 1.39 2.186 2.186 0 0 0 .36.03 1.956 1.956 0 0 0 .82-.18l.57.57zm2.06 0 1.5-6h.44l1.5 6zm12.72 0h-3v-6h-2v6h-2.22l-1.67-6.69.57-.57a1.923 1.923 0 0 0 .82.18 2.186 2.186 0 0 0 .36-.03 1.965 1.965 0 0 0 1.55-1.34l1.11-3.08a6.95 6.95 0 0 1 4.48 6.53z"
}));

function SvgExperience(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.fb79536d.svg";
export { ForwardRef as ReactComponent };